import {
	CoachReviewPromises,
	GPGameTeamResponse,
	GameClipIntervalRequest,
	GameEventDataExportRequest,
	GamePageLazyResponse,
	HighlightHandlers,
	PlayerGradingSubmitPayload,
	GameEventCommentProps,
	GPGamePlayerResponse,
	VideoSidebar,
	RatingPutRequest,
} from "../../../types";
import type { ReportEventErrorHandler } from "../../../report-error";
import { useGameStore } from "../../../store";
import { EventInVideo } from "../EventList/EventInVideo";
import { Sidebar } from "../Sidebar";
import { RefObject } from "react";
import { MediaPlayerInstance } from "@vidstack/react";

interface VideoPlayerSidebarProps {
	show: boolean;
	fullscreen: boolean | undefined;
	showCoachingTools: boolean;
	highlightsHandlers: HighlightHandlers;
	handleCreateClip: (intervals: GameClipIntervalRequest[], name: string, description?: string) => void;
	handleOpenEditTeamSheetModal: (team: GPGameTeamResponse) => void;
	handleGameEventDataExport: (gameEventDataExportRequest: GameEventDataExportRequest) => void;
	handleTeamSheetDataExport: (type: string) => void;
	playerRef: RefObject<MediaPlayerInstance> | null;
	gameDataLazy?: GamePageLazyResponse;
	handleSetPlayerRating?: (id: number, rating: RatingPutRequest) => void;
	handleSubmitPlayerGrading?: (payload: PlayerGradingSubmitPayload) => void | Promise<void>;
	toastMessage: (type: string, message: string) => void;
	gameEventComment?: GameEventCommentProps;
	players?: GPGamePlayerResponse[];
	onReportError?: ReportEventErrorHandler;
	coachReviewPromises?: CoachReviewPromises;
	userId?: number;
	activeContextTeamId?: number;
}

export function VideoPlayerSidebar({
	show,
	fullscreen,
	showCoachingTools,
	gameDataLazy,
	highlightsHandlers,
	handleCreateClip,
	handleGameEventDataExport,
	handleOpenEditTeamSheetModal,
	handleTeamSheetDataExport,
	playerRef,
	handleSetPlayerRating,
	handleSubmitPlayerGrading,
	toastMessage,
	gameEventComment,
	players,
	onReportError,
	coachReviewPromises,
	userId,
	activeContextTeamId,
}: VideoPlayerSidebarProps) {
	const { sidebar, events, gameData } = useGameStore();

	if (!gameData) {
		return null;
	}

	return (
		<>
			{sidebar !== VideoSidebar.EventList && sidebar !== VideoSidebar.Timeline && sidebar !== VideoSidebar.EventsWithComments && (
				<EventInVideo fullscreenSidebar={show && fullscreen && !!sidebar} events={events} playerRef={playerRef} />
			)}
			{show && sidebar && fullscreen && (
				<Sidebar
					gameDataLazy={gameDataLazy}
					showCoachingTools={showCoachingTools}
					handleCreateClip={handleCreateClip}
					highlightsHandlers={highlightsHandlers}
					gameData={gameData}
					handleOpenEditTeamSheetModal={handleOpenEditTeamSheetModal}
					handleGameEventDataExport={handleGameEventDataExport}
					handleTeamSheetDataExport={handleTeamSheetDataExport}
					handleSetPlayerRating={handleSetPlayerRating}
					handleSubmitPlayerGrading={handleSubmitPlayerGrading}
					toastMessage={toastMessage}
					gameEventComment={gameEventComment}
					players={players}
					variant="video"
					onReportError={onReportError}
					coachReviewPromises={coachReviewPromises}
					userId={userId}
					activeContextTeamId={activeContextTeamId}
				/>
			)}
		</>
	);
}
